module.exports = __webpack_public_path__ + "static/img/8.7983162.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/list/8.png
// module id = j0Fd
// module chunks = 1